module.exports = __webpack_public_path__ + "static/media/edit_student_schedule_icon_legend.824e87e9.mov";